// ABOUTME: Client component wrapping children in Zapier's UniversalLayout for consistent nav chrome.
// ABOUTME: UniversalLayout fetches its own data client-side using the JWT cookie on zapier.com.
"use client";

import { UniversalLayout } from "@zapier/universal-layout";

export default function AppLayout({ children }: { children: React.ReactNode }) {
  return (
    <UniversalLayout
      mode="in-app"
      currentUrl="/approvals"
      trackEvent={() => {}}
      showSimplifiedFooter
      renderFooter={() => false}
      renderAlertBanner={() => null}
      mainContentId="approvals-main"
    >
      {children}
    </UniversalLayout>
  );
}
